export const INVITE_CODE_REG = /(https:\/\/chat.debugmode.cn|https:\/\/chat.xiaoheihe.cn|http:\/\/chat.top)\/[A-Za-z\d]+/

export const CROSSHAIR_SHARE_CODE_REG = /(https:\/\/chat.debugmode.cn|https:\/\/chat.xiaoheihe.cn|http:\/\/chat.top)\/ch[A-Za-z\d]+/